import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100dvh',
});

export const card: TRuleWithTheme = ({ theme }) => ({
    width: '100%',
    maxWidth: '550px',
    borderRadius: '0.25rem',

    padding: '1.5rem',

    backgroundColor: theme.colors.backgroundsSecondary,
});

export const appUrl: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.foregroundsSecondary,
    fontWeight: 700,
});

export const description: TRuleWithTheme = () => ({
    marginTop: '1.5rem',
    marginBottom: '2.5rem',
});

export const loginButton: TRuleWithTheme = () => ({
    whiteSpace: 'wrap',

    '&.ant-btn': {
        height: 'unset',
    },
});
